'use server';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const findSimilarArticles = async (embedding) => {
  try {
    const response = await fetch(`${API_URL}/similar-articles`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ embedding }),
    });
    const data = await response.json();

    return !!data ? data : null;
  } catch (error) {
    console.error('Error fetching similar articles:', error);
    throw error;
  }
};

// New: server-side search using API /api/search
export const serverSearch = async (query) => {
  const response = await fetch(`${API_URL}/search`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query })
  });
  if (!response.ok) throw new Error(`Search failed (${response.status})`);
  return response.json();
};

export const checkFile = async (source, id) => {
  try {
    const checkPath = `${API_URL.replace(/\/api$/, '')}/check-file/${source}/${id}`;
    console.log('Check file :', checkPath);
    const response = await fetch(checkPath);

    if(!!response){
      const data = await response.json();

      return !!data ? data : null;
    }
  } catch (error) {
    console.error('Error fetching article:', error);
    throw error;
  }
}

export const fetchArticle = async (source, id) => {
  try {
    const basePath = source === 'eflux' 
          ? `${API_URL.replace(/\/api$/, '')}/data/eflux_json` 
          : `${API_URL.replace(/\/api$/, '')}/data/kadist_json`;
        
    console.log('Attempting to fetch article from:', `${basePath}/${id}.json`);
    const response = await fetch(`${basePath}/${id}.json`);

    if(!!response){
      const data = await response.json();

      return !!data ? data : null;
    }
  } catch (error) {
    console.error('Error fetching article:', error);
    throw error;
  }
}

export const fetchIdeas = async (source, id) => {
  try {
    const ideasBasePath = source === 'eflux' 
          ? `${API_URL.replace(/\/api$/, '')}/data/eflux_json_ideas_embeddings` 
          : `${API_URL.replace(/\/api$/, '')}/data/kadist_json_ideas_embeddings`;
        
          console.log('Attempting to fetch ideas with embeddings from:', `${ideasBasePath}/${id}.json`);
    const response = await fetch(`${ideasBasePath}/${id}.json`);

    if(!!response){
      const data = await response.json();

      return !!data ? data : null;
    }
  } catch (error) {
    console.error('Error fetching article:', error);
    throw error;
  }
}